import React from "react";
import { toast } from "sonner";
import { useAdminAuth } from "@/hooks/useAdminAuth";
import { useAdminList } from "@/hooks/useAdminList";
import AdminTable from "@/components/admin/AdminTable";

const STATUS_OPTIONS = [
  { value: "novo", label: "Novo" },
  { value: "respondido", label: "Respondido" },
];

const formatDate = (iso) =>
  new Date(iso).toLocaleString("pt-BR", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });

const COLUMNS = [
  { key: "name", label: "Nome" },
  {
    key: "contato",
    label: "Contato",
    render: (r) => (
      <div className="flex flex-col gap-0.5">
        <a href={`mailto:${r.email}`} className="hover:text-[var(--mn-gold)]">{r.email}</a>
        {r.phone && <span className="text-xs text-[var(--mn-dark)]">{r.phone}</span>}
      </div>
    ),
  },
  {
    key: "message",
    label: "Mensagem",
    render: (r) => (
      <span className="block max-w-[320px] truncate" title={r.message}>
        {r.message}
      </span>
    ),
  },
  { key: "created_at", label: "Recebido em", render: (r) => formatDate(r.created_at) },
];

export default function AdminContatos() {
  const { pin } = useAdminAuth();
  const { items, loading, error, remove, updateStatus } = useAdminList("/contacts", pin);

  const handleDelete = async (row) => {
    if (!window.confirm(`Remover a mensagem de ${row.name}?`)) return;
    try {
      await remove(row.id);
      toast.success("Mensagem removida");
    } catch {
      toast.error("Falha ao remover");
    }
  };

  const handleStatusChange = async (id, status) => {
    try {
      await updateStatus(id, status);
    } catch {
      toast.error("Falha ao atualizar status");
    }
  };

  return (
    <div className="p-6 lg:p-10">
      <div className="mb-6">
        <span className="mn-eyebrow">Contatos</span>
        <h2 className="font-serif-display font-extrabold text-2xl text-[var(--mn-black)] mt-3">
          {items.length} mensagem(ns) recebida(s)
        </h2>
      </div>
      <AdminTable
        columns={COLUMNS}
        rows={items}
        loading={loading}
        error={error}
        emptyLabel="Nenhuma mensagem de contato recebida ainda."
        statusOptions={STATUS_OPTIONS}
        onStatusChange={handleStatusChange}
        onDelete={handleDelete}
        getRowTestId={(r) => `admin-contact-${r.id}`}
      />
    </div>
  );
}
